import * as React from 'react';
import { Carousel } from '../../Carousel';
import { Ticker } from '../../Ticker';
import * as styles from './TgbSliderTemplate.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function TgbSliderTemplate(_ref) {
  var image1 = _ref.image1,
    image2 = _ref.image2,
    image3 = _ref.image3,
    title = _ref.title,
    description = _ref.description,
    site = _ref.site,
    footnote = _ref.footnote,
    url = _ref.url;
  var media = React.useMemo(function () {
    return [image1, image2, image3].filter(Boolean).map(function (url) {
      return {
        url: url
      };
    });
  }, [image1, image2, image3]);
  return /*#__PURE__*/_jsxs("a", {
    href: url,
    target: "_blank",
    rel: "noreferrer noopener nofollow",
    className: styles['container'],
    children: [/*#__PURE__*/_jsx("span", {
      className: styles['ad-label'],
      children: "\u0420\u0435\u043A\u043B\u0430\u043C\u0430"
    }), /*#__PURE__*/_jsx("div", {
      className: styles['image'],
      children: /*#__PURE__*/_jsx(Carousel, {
        media: media,
        loop: true
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles['main'],
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles['content'],
        children: [/*#__PURE__*/_jsx("h4", {
          className: styles['title'],
          children: title
        }), /*#__PURE__*/_jsx("p", {
          className: styles['text'],
          children: description
        }), site && /*#__PURE__*/_jsx("div", {
          className: styles['site'],
          children: site
        })]
      }), footnote && /*#__PURE__*/_jsx("div", {
        className: styles['note'],
        children: /*#__PURE__*/_jsx(Ticker, {
          text: footnote
        })
      })]
    }), /*#__PURE__*/_jsx("button", {
      type: "button",
      className: styles['action-control'],
      children: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0441\u0430\u0439\u0442"
    })]
  });
}